import { useMemo } from "react"
import { Operation } from "../../../../operations"
import { Delivery, DeliveryMethod } from "../../../state/types"
import { DeliveryStatsTable } from "../../delivery-stats-table/deliveryStatsTable"

type Props = {
    delivery: Delivery
    operation: Operation
}

export const DeliveryItemsStatsTable = (props: Props) => {
    const { delivery, operation } = props

    const rows = useMemo(() => delivery.items.map(item => delivery.method === DeliveryMethod.RETURN ? {
        itemId: item.itemId,
        quantity: item.quantity,
        defective: item.defectiveQuantity || 0,
        nonDefective: item.quantity - (item.defectiveQuantity || 0)
    } : {
        itemId: item.itemId,
        quantity: item.quantity,
        dispatched: item.quantity - item.deliveredQuantity - item.notDeliveredQuantity,
        delivered: item.deliveredQuantity,
        notDelivered: item.notDeliveredQuantity
    }), [delivery.items, delivery.method])

    return (
        <DeliveryStatsTable
            deliveryMethod={delivery.method}
            items={rows}
            operation={operation}
        />
    )
}
